import { BaseMapper, type Nullable } from '@ps/utils';
import type {
  SupplierGroupTemplate,
  SupplierGroupTemplateMember,
} from '@ps/survey-utils';

import { SupplierGroupTemplateDto } from '../dtos/supplier-group-template.dto';

export class SupplierGroupTemplateMapper extends BaseMapper<
  SupplierGroupTemplateDto,
  SupplierGroupTemplate
> {
  public fromDto(dto: SupplierGroupTemplateDto): SupplierGroupTemplate {
    return {
      id: dto.id,
      buyerId: dto.buyerId,
      groupName: dto.groupName,
      allocation: this._mapNumericValue(dto.allocation),
      isCustomAllocation: !!dto.is_custom_allocation,
      members: dto.suppliers.map((member) => this._mapMember(member)),
    };
  }

  private _mapMember(member: {
    id: number;
    name: string;
    allocation: Nullable<number>;
  }): SupplierGroupTemplateMember {
    return {
      id: member.id,
      name: member.name,
      allocation: this._mapNumericValue(member.allocation),
    };
  }

  // Absence is a real state — null means "no allocation set" — so this returns
  // Nullable<number> rather than escaping an Option; 0 stays a valid value.
  private _mapNumericValue(
    value: Nullable<number | string> | undefined,
  ): Nullable<number> {
    if (typeof value !== 'number' && typeof value !== 'string') {
      return null;
    }
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
  }
}
